import { faCalendar } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DatePickerInput } from '@mantine/dates'
import { getMomentDateMax } from 'App/data-export/components/DataExport/DataExportModalDrawer/_utils/getMomentDateMax'
import { getMomentDateMin } from 'App/data-export/components/DataExport/DataExportModalDrawer/_utils/getMomentDateMin'
import { InputWrapper } from 'App/data-export/components/DataExport/InputWrapper'
import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { constructDateWithTimeZone } from 'components/DateRangePicker/_utils/constructDateWithTimeZone'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import React, { useCallback, useMemo } from 'react'
import { colors } from 'settings/colors'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { getIsoWithoutTheZ } from 'utils/getIsoWithoutTheZ'

export const DateRangeSelect = () => {
  const {
    formState: { propertyId, dateRange },
    formErrors,
  } = dataExportStore.useSelector((s) => s)

  const userTimezone = moment.tz.guess()

  const propertyTimezone = useMemo(() => {
    return fieldAssetStore.getState().properties?.[Number(propertyId)]?.timezone ?? moment.tz.guess()
  }, [propertyId])

  const changeDateRange = useCallback(
    (value: [string | null, string | null]) => {
      dataExportStore.actions.changeDateRange([
        value[0] ? getIsoWithoutTheZ(moment.tz(value[0], propertyTimezone).startOf('day')) : null,
        value[1] ? getIsoWithoutTheZ(moment.tz(value[1], propertyTimezone).endOf('day')) : null,
      ])
    },
    [propertyTimezone],
  )

  const dateFrom = dateRange[0] ? constructDateWithTimeZone(dateRange[0], userTimezone) : null
  const dateTo = dateRange[1] ? constructDateWithTimeZone(dateRange[1], userTimezone) : null
  const minDate = constructDateWithTimeZone(getMomentDateMin(propertyTimezone).toString(), propertyTimezone)
  const maxDate = constructDateWithTimeZone(getMomentDateMax(propertyTimezone).toString(), propertyTimezone)

  return (
    <InputWrapper
      label={translate.phrases.banyanApp('Select Date Range')}
      error={!!formErrors.dateRange}
      errorMessage={formErrors.dateRange}
    >
      <DatePickerInput
        rightSection={<FontAwesomeIcon css={{ color: colors.grey800, fontSize: 16 }} icon={faCalendar} />}
        valueFormat={translate.dates.getMomentFormat('MMM D, YYYY')}
        placeholder={translate.phrases.banyanApp('Select Date Range')}
        allowSingleDateInRange={true}
        type="range"
        value={[dateFrom, dateTo]}
        onChange={changeDateRange}
        minDate={minDate}
        maxDate={maxDate}
      />
    </InputWrapper>
  )
}
